import React, {useEffect, useState} from "react";
import './CalibrationValues.scss'

import {useDispatch, useSelector} from "react-redux";
import Spinner from "../_common/Spinner";
import List from "../_common/List";
import {ReactComponent as EditIcon} from "../../assets/icons/edit.svg";

import {toggleModal} from "../../store/actions/toggleModalActions";
import {
    deleteCalibrationValue,
    getCalibrationMeasurementTypes,
    getCalibrationValues,
    selectCalibrationValue
} from "../../store/actions/calibrationValuesActions";
import CalibrationValuesModal from "./CalibrationValuesModal";
import ConfirmationModal from "../_common/ConfirmationModal";
import {deleteFieldGroup} from "../../store/actions/fieldGroupsActions";

const selector = state => {
    const { language, calibrationValues, modalState } = state;
    return {
        t: language.translator,
        pending: calibrationValues.pending,
        calibrationValues: calibrationValues.calibrationValues,
        selected: calibrationValues.selected,
        modalState: modalState
    }
};

const CalibrationValues = () => {
    const dispatch = useDispatch();

    const {
        t, pending, calibrationValues, selected, modalState
    } = useSelector(selector)

    useEffect(() => {
        dispatch(getCalibrationValues())
        dispatch(getCalibrationMeasurementTypes())
    },[])

    const toggleEditCalibrationValue = (item) => {
        dispatch(toggleModal(true, 'Edit Calibration Value Set'))
    }

    const toggleDeleteModal = () => {
        dispatch(toggleModal(true, 'Delete Calibration Value Set'))
    }
    const deleteCalibrationValueSetMethod = (id) => {
        dispatch(deleteCalibrationValue(id))
        dispatch(toggleModal(false, 'Delete Calibration Value Set'))
    }

    return (
        <div className="CalibrationValues">
            <div className="leftContainer">
                <div className="listContainer">
                    <div className="calibrationValuesHeader">
                        <span>{t.gettext('Calibration Value Sets')}</span>
                        <div className='addAlertRuleBtn' onClick={() => dispatch(toggleModal(true, 'Add Calibration Value Set'))}>
                            <span className='material-icons'>add</span>
                        </div>
                    </div>
                    {pending
                        ? <div className='page'>
                            <Spinner size={300}/>
                        </div>
                        : <List
                            scroll
                            roundTopCorners
                            items={calibrationValues}
                            // page={page}
                            itemsPerPage={10}
                            // pageCount={pageCount}
                            // itemsCount={itemsCount}
                            columnsNames={['Name', 'Measurement Type', 'Unit', '', '']}
                            columns={['setName', 'measurementType', 'unitName', '','']}
                            columnsWidths={['30%', '25%', '25%', '5%','5%']}
                            selectItemMethod={selectCalibrationValue}
                            selected={selected.calibrationValues}
                            editColumn={4}
                            deleteColumn={5}
                            editMethod={toggleEditCalibrationValue}
                            deleteMethod={toggleDeleteModal}
                        />
                    }
                </div>
            </div>
            <div className="rightContainer">
                <div className="calibrationValuesHeader">
                    <span>{t.gettext('Thresholds')}</span>
                </div>
                {selected.calibrationValue && (
                    <div className="thresholdsContainer">
                        <div className="thresholdsHeader">
                            <div style={{width: '49%'}} className="thresholdsHeaderCell">
                                {t.gettext('Org Value')}
                            </div>
                            <div style={{width: '49%'}} className="thresholdsHeaderCell">
                                {t.gettext('3rd Party Value')}
                            </div>
                        </div>
                        {selected.calibrationValue.values.map(el => (
                            <div className="thresholdsListItem">
                                <div  style={{width: '49%'}} className="thresholdsItemCell">{el.originalValue}</div>
                                <div  style={{width: '49%'}} className="thresholdsItemCell">{el.thirdPartyValue}</div>
                            </div>
                        ))}

                    </div>
                )}
            </div>
            {(modalState.flag && modalState.modal === 'Add Calibration Value Set') &&
                <CalibrationValuesModal />
            }
            {(modalState.flag && modalState.modal === 'Edit Calibration Value Set') &&
                <CalibrationValuesModal
                    edit
                />
            }
            {(modalState.flag && modalState.modal === 'Delete Calibration Value Set') &&
                <ConfirmationModal
                    text={'Do you want to delete'}
                    deleteModal
                    calibrationSet
                    item={selected.calibrationValue}
                    closeMethod={() =>  dispatch(toggleModal(false, 'Delete Calibration Value Set'))}
                    confirmMethod={() => deleteCalibrationValueSetMethod(selected.calibrationValue.setId)}
                    confirmButtonText={'Delete'}
                />
            }
        </div>
    )
}

export default CalibrationValues
